import React, { useCallback, useContext } from 'react';
import classnames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { FirstTimeFlag } from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { useFirstTimeFlag } from '@wix/da-shared-react/pkg/redux/firstTimeFlags/hooks';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './TierPublishSuccessModal.scss';

interface Props {
  onClose: () => void;
}

const TierPublishSuccessModal: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const canShowFTUE = useFlag('ms_ads');

  const { hasFlag, dropFlag } = useFirstTimeFlag(
    FirstTimeFlag.IsMsFirstTierNotCreated
  );

  const showFTUEVariant = canShowFTUE && !isMobile && hasFlag;

  const onCloseModal = useCallback(() => {
    onClose();
    showFTUEVariant && dropFlag();
  }, [onClose, showFTUEVariant, dropFlag]);

  return (
    <MessageModal
      variant={showFTUEVariant ? 'horizontal' : 'vertical'}
      className={classnames(showFTUEVariant && s['ftue-modal'])}
      title={t('page.subscriptions.publishedSuccessPopup.title')}
      message={
        showFTUEVariant ? (
          /* prettier-ignore */
          <Trans i18nKey="page.subscriptions.publishedSuccessPopup.ftue.message">
            Now you can add tasty deviations and posts to attract subscribers.

            We’ve also added banners to your profile and deviations to let everyone
            know that you’re open for business. You can turn these promotions off in your
            <a href={URLS.SETTINGS_SUBSCRIPTIONS}>Settings</a>.
          </Trans>
        ) : (
          t('page.subscriptions.publishedSuccessPopup.message')
        )
      }
      image={<div className={s['illustration']} />}
      confirmButtonLabel={t(
        'page.subscriptions.publishedSuccessPopup.button.label'
      )}
      onConfirm={onCloseModal}
    />
  );
};
TierPublishSuccessModal.displayName = 'TierPublishSuccessModal';

export default TierPublishSuccessModal;
